export enum PurchaseSort {
  'shop_name' = 'n',
  'purchase_amount' = 'a',
  'purchase_status_id' = 's',
  'cashback_amount' = 'c',
  'purchase_date' = 'd',
}
